export const RANDOM_NAMES = [
	"Adorable Axolotl",
	"Angry Aardvark",
	"Bashful Badger",
	"Bouncy Bunny",
	"Chatty Camel",
	"Crabby Crab",
	"Dainty Dodo",
	"Daring Dolphin",
	"Dizzy Duckling",
	"Drowsy Dragon",
	"Electric Eel",
	"Fancy Flamingo",
	"Fuzzy Ferret",
	"Fuzzy Fox",
	"Gentle Gerbil",
	"Gloomy Goose",
	"Grumpy Goat",
	"Happy Hamster",
	"Humble Hedgehog",
	"Idle Inchworm",
	"Jumpy Jaguar",
	"Kooky Kiwi",
	"Lazy Llama",
	"Loopy Lion",
	"Loyal Lizard",
	"Lucky Lemur",
	"Mellow Monkey",
	"Mighty Mollusk",
	"Mythic Moose",
	"Nervous Narwhal",
	"Nifty Newt",
	"Oblong Otter",
	"Patient Penguin",
	"Quirky Quokka",
	"Royal Rabbit",
	"Salty Seagull",
	"Silent Snake",
	"Silly Salamander",
	"Sleepy Shark",
	"Sloppy Sloth",
	"Speedy Stingray",
	"Stoic Starfish",
	"Tranquil Turtle",
	"Ultimate Unicorn",
	"Upbeat Urchin",
	"Vengeful Vulture",
	"Wacky Weasel",
	"Witty Wolf",
	"Yawning Yak",
	"Zoomy Zebra",
]
